(function () {
	'use strict';

	angular.module('qbePortal').controller('QBTable', QBTableController);
	QBTableController.$inject = ['$scope', '$timeout', 'aggregatedRemoveService'];

	function QBTableController($scope, $timeout, aggregatedRemoveService) {
		var vm = this;
		// vm.isEditable = true;

		vm.$onInit = function () {
			vm.selectedRows = [];
			vm.editingRows = [];
			vm.allRowsSelected = false;
			vm.newRow = {};
			vm.isEditable = (vm.editDisabled != true);
			vm.isAddable = (vm.addDisabled != true);
			vm.IDPrefix = vm.sectionName + '_' + vm.name;

			vm.isRowInEditMode = function (row) {
				return vm.editingRows.indexOf(row) !== -1;
			}

			vm.onEditRow = function (row) {
				if (vm.editingRows.indexOf(row) == -1)
					vm.editingRows.push(row);
			}

			vm.isAddRequired = function () {
				return vm.rows.length == 0;
			}

			vm.onEditDone = function (row) {
				var rowIndex = vm.editingRows.indexOf(row);
				if (rowIndex != -1) {
					vm.editingRows.splice(rowIndex, 1);
					updateParentSection();
				}
			}

			vm.isAddEnabled = function () {
				if (Object.keys(vm.newRow).length < vm.columns.length)
					return false;

				for (var col in vm.newRow) {
					if (vm.newRow[col] === null || vm.newRow[col] == '') {
						return false;
					}
				}
				return true;
			}

			vm.onAdd = function () {
				if (vm.isAddEnabled()) {
					vm.rows.push(vm.newRow);
					updateParentSection();
					vm.newRow = {};
					$timeout(function () {
						if (vm.rows.length > 0) {
							$(document).trigger('enhance.tablesaw');
						}
					}.bind(vm), 0);
				}
			}

			vm.onSelectAllChanged = function () {
				if (vm.allRowsSelected) {
					vm.selectedRows = vm.rows.map(function () {
						return true
					});
				} else {
					vm.selectedRows = vm.rows.map(function () {
						return false
					});
				}
			}

			vm.onRemoveSelection = function () {
				angular.forEach(vm.selectedRows, function (row, index) {
					if (row)
						aggregatedRemoveService.markForDelete(vm.name, vm.rows[index]);
				});

				var rows = vm.rows.filter(function (row, index) {
					return vm.selectedRows[index] != true;
				})

				vm.selectedRows = [];
				vm.rows = rows;
				updateParentSection();
			}


			vm.registerHierarchy = function (name, setHierarchyFn) {
				vm.setHierarchy({
					name: name,
					setHierarchyFn: setHierarchyFn
				});
			}
		}

		// trigger table saw after binding complete.
		$timeout(function () {
			if (vm.rows.length > 0) {
				$(document).trigger('enhance.tablesaw');
			}
		}.bind(vm), 0);

		function updateParentSection() {
			vm.update({
				name: vm.name,
				value: vm.rows
			});
			// $scope.$broadcast('table-number-of-rows-changed') ;
		}

	}

	angular.module('qbePortal').component('qbTable', {
		templateUrl: '../ngviews/components/qbMultiEntryTable.html',
		controller: QBTableController,
		controllerAs: 'vm',
		bindings: {
			update: '&',
			name: '@',
			sectionName: '<',
			valueAggregator: '<',
			rows: '=',
			columns: '=',
			editDisabled: '<',
			addDisabled: '<',
			setHierarchy: '&',
		}
	});
})();
